import { App as CapApp } from '@capacitor/app';
import { isNative, isAndroid } from './env';

// Android hardware back button. By default Capacitor closes the app on back
// from any screen — we want it to navigate within the React Router history,
// and only minimize when at the start of history.
//
// Returns an unsubscribe function. Pass the rootPaths the app considers
// "home" (back from these minimizes instead of pushing into history).
export function bindHardwareBack(history, { rootPaths = ['/', '/ChargePointStation'] } = {}) {
    if (!isNative || !isAndroid) return () => {};
    let handle;
    CapApp.addListener('backButton', () => {
        const onRoot = rootPaths.includes(history.location?.pathname);
        if (onRoot) {
            CapApp.minimizeApp().catch(() => {});
        } else if (history.length > 1) {
            history.goBack();
        } else {
            CapApp.minimizeApp().catch(() => {});
        }
    }).then((h) => { handle = h; });
    return () => { handle?.remove?.(); };
}

// Generic app lifecycle listener. Returns unsubscribe.
//   onResume / onPause receive ({ isActive }).
export function bindAppStateChange({ onResume, onPause } = {}) {
    if (!isNative) return () => {};
    let handle;
    CapApp.addListener('appStateChange', ({ isActive }) => {
        if (isActive) {
            onResume?.({ isActive });
        } else {
            onPause?.({ isActive });
        }
    }).then((h) => { handle = h; });
    return () => { handle?.remove?.(); };
}
